import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';

import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {describeSessionTypeLocation,getSessionRate} from '../../helpers/sessionTypes';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import TitleDivider from "../patientSignup/TitleDivider";
import FormLayout from "../patientSignup/FormLayout";
import SessionTypeLocationIcon from './SessionTypeLocationIcon';

import './SelectSessionTypeForm.scss';

const SelectSessionTypeForm = props => {
  const {sessionType, sessionTypes, onSubmit, selectedProviderId} = props;
  const [selectedSessionType, setSelectedSessionType] = useState(sessionType);
  const providersQuery = useGetProvidersQuery(
    {id: selectedProviderId},
    {skip: !selectedProviderId}
  );
  const p = get(providersQuery, 'data', []).find(
    p => p.id === parseInt(selectedProviderId, 10)
  );
  const visibleSessionTypes = sessionTypes.filter(st =>
    props.isProvider ? true : !st.hide_from_patients 
  );
  return (
    <Stack>
      <Stack direction='column' className='SelectSessionTypeForm'>
        <TitleDivider text='Choose Appointment Type' width='fit-content'/>
        {
          !visibleSessionTypes || !visibleSessionTypes.length
            ? <Typography align='center' className="SelectSessionTypeForm__no-sessions">
              Sorry, it looks like this provider has no sessions available.
            </Typography>
            : null
        }

        {visibleSessionTypes && (
          <Box className="session-type-list">
            <Stack direction='column' gap={2} padding='15px 0 15px 0'>
              {
                visibleSessionTypes.map(s =>
                  <Stack
                    direction="row"
                    fullWidth
                    onClick={() => setSelectedSessionType(s)}
                    className={`session-type-item ${selectedSessionType?.id === s.id ? 'session-type-item--selected' : ''}`}
                  >
                    <Stack justifyContent='center' alignItems='start' sx={{minWidth: '57px'}}>
                      <SessionTypeLocationIcon sessionType={s} />
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' className="session-type-item__details">
                      <Stack gap={0.25} sx={{minHeight: '33px'}} justifyContent='center'>
                        <Typography className='session-type-title' variant='large600Tight' textAlign='left'>
                          {s.title}
                        </Typography>
                        <Typography variant='small' color='text.light' textAlign='left'>
                          {s.duration_minutes} minutes
                          {getSessionRate(s) ? ` | $${getSessionRate(s)}` : ''}
                        </Typography>
                      </Stack>
                      <Typography className='session-type-location' variant='small' color='text.light' lineHeight='1.067rem'>
                        {describeSessionTypeLocation(s)}
                      </Typography>
                    </Stack>
                  </Stack>
                )
              }
            </Stack>
          </Box>
        )}
      </Stack>
      {
        selectedSessionType && selectedSessionType.description &&
          <Typography 
            variant='large' 
            lineHeight='1.067rem' 
            color='text.light' 
            sx={{marginTop: '24.75px', marginBottom: '21.75px'}}
            style={{whiteSpace: 'pre-line'}}
          >
            {selectedSessionType.description}
          </Typography>
      }
      <Button 
        sx={{alignSelf: 'center', width: '215px', marginTop: '9px'}}
        variant='primaryGradient'
        size='medium'
        fullWidth={false}
        onClick={() => onSubmit(selectedSessionType.id)}
        disabled={!selectedSessionType}
        >
        Schedule a Time
      </Button>
      {
        props?.allowSkipSessionType &&
        <Button
          variant='text'
          size='medium'
          fullWidth={false}
          onClick={props.onScheduleManually}
        >
          Skip and Schedule Later
        </Button>
      }
    </Stack>
  );
};

SelectSessionTypeForm.defaultProps = {
  onSubmit: () => console.error(
    new Error('SelectSessionTypeForm.onSubmit')
  ),
};

SelectSessionTypeForm.propTypes = {
  selectedProvider: PropTypes.object,
  selectedPatient: PropTypes.object,
  isProvider: PropTypes.bool,
  sessionType: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default SelectSessionTypeForm;
